module.exports = __webpack_public_path__ + "media/images/countrysquared/bt-69f5aa0d5d05b0974a81fc228793c612.svg";